export default __webpack_public_path__ + "static/media/31.662d26fb.svg";